<template>
    <CustomSelectOne :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                     item-label="name" :item-value="itemValue" :label="label" v-if="loading" :required="required"
                       :placeholder="placeholder" :filter="filter" :rules="rules"/>
</template>

<script>
    import {getCountries} from "@/swagger/vue-api-client";
    import CustomSelectOne from "./inner/CustomSelectOne";

    export default {
        name: "CustomSelectOneCountry",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            required: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: "",
            },
            modelValue: null,
            itemValue: {
                type: String,
                default: "name",
            },
            filter: {
                type: Boolean,
                default: false,
            },
            rules: undefined,
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        data() {
            return {
                items: [],
                loading: false,
            };
        },

        beforeMount() {
            getCountries().then((response) => {
                this.items = response.data;
                this.loading = true;
            });
        },

        components: {CustomSelectOne},
    };
</script>

<style scoped>

</style>
